// ============================================================
// manufacturing.nav.ts — Phase-4 migration descriptor
// ------------------------------------------------------------
// Component-free, data-only navigation descriptor for the Admin
// Manufacturing hub group (Devices / Components / Manufacturing
// settings). Imports ONLY pure types/constants (@twist/ui-navigation
// types + @twist/core security primitives) — no component / feature
// code — so the registry stays a pure data graph.
//
// Mirrors the legacy sideNavConfig "Admin › Manufacturing hub" group:
// the group-parent + every sub-item are gated TWIST_ADMIN_ONLY
// (orgTypes: [TwistAdmin]) — identical to the legacy group constraint.
//
// Whole-group migration: the children carry the `sidebar` surface so the
// legacy "Manufacturing hub" group de-dups out (every sub-item path is
// piloted). Production batches (/manufacturing) and Manufacturing settings
// (/manufacturing/settings) are live routes served by @twist/feature-manufacturing.
// The registry projects this as a SINGLE top-level "Manufacturing hub" leaf
// (→ /manufacturing).
// ============================================================
import { TWIST_ADMIN_ONLY } from '@twist/core';
import type { NavDescriptor } from '@twist/ui-navigation';

export const manufacturingNav: NavDescriptor = {
  id: 'manufacturing',
  path: '/manufacturing',
  label: 'Manufacturing hub',
  icon: 'gearsDatabase',
  group: 'Admin',
  // Admin section = 40s; Manufacturing hub first (matches the recovered
  // sideNavConfig order: Manufacturing hub, Definitions, Security,
  // Summaries).
  order: 40,
  surfaces: ['sidebar', 'palette'],
  security: TWIST_ADMIN_ONLY,
  children: [
    {
      id: 'manufacturing-devices',
      path: '/manufacturing',
      label: 'Production batches',
      group: 'Admin',
      surfaces: ['sidebar', 'palette'],
      security: TWIST_ADMIN_ONLY,
    },
    {
      id: 'manufacturing-definitions',
      path: '/manufacturing/definitions',
      label: 'Device definitions',
      group: 'Admin',
      surfaces: ['sidebar', 'palette'],
      security: TWIST_ADMIN_ONLY,
    },
    {
      id: 'manufacturing-settings',
      path: '/manufacturing/settings',
      label: 'Manufacturing settings',
      group: 'Admin',
      surfaces: ['sidebar', 'palette'],
      security: TWIST_ADMIN_ONLY,
    },
  ],
};
